import React from 'react';

import Editor from 'components/Editor';
import { Checkbox } from 'components/Misc/Form';
import { Button } from 'components/Misc/Form';

import { useExamProfileStore } from 'store/exam/useExamProfileStore';
import { useTaskCreateStore } from 'store/task/useTaskCreateStore';

const Option = ({ option, questionKey }) => {
	// Use exam's profile store
	const slug = useExamProfileStore(state => state.exam.slug);

	// Use task's create store
	const [onChangeOption, onRemoveOption] = useTaskCreateStore(state => [state.onChangeOption, state.onRemoveOption]);

	// Handles option's onChange event
	const onChange = change => onChangeOption(questionKey, option.key, change);

	// Handles question's onRemove event
	const onRemove = () => onRemoveOption(questionKey, option.key);

	return (
		<div className="flex items-center gap-4">
			{/* Option's actions */}
			<div className="flex flex-col gap-4">
				<Checkbox
					small
					name="correct"
					value={option.correct}
					onChange={onChange}
				/>

				<Button
					small
					square
					icon="delete"
					theme="danger"
					onClick={onRemove}
					className="font-normal"
				/>
			</div>

			{/* Option's content */}
			<Editor
				type="answer"
				name="content"
				path="exams"
				folder={slug}
				value={option.content}
				onChange={onChange}
			/>
		</div>
	);
};

export default Option;